<template>
  <div class="container padding-y-md">
    <div
      class="bandana-new-pack-notice position-relative"
      style="background-color: var(--fa-purple); border-radius: var(--border-radius-lg)"
    >
      <div style="position: relative; z-index: 1">
        <div
          class="display-flex flex-items-center flex-wrap tablet:align-between align-center padding-y-md padding-x-xl"
          style="gap: var(--spacing-md)"
        >
          <div class="display-flex flex-items-center tablet:flex-wrap">
            <font-awesome-icon
              :icon="$v7.solid.faAlien8bit"
              size="2x"
              style="color: var(--fa-dk-purple)"
            />
            <p class="text-left margin-left-sm margin-y-0">
              <strong>{{ headlineText }}</strong> •
              <site-link
                :to="{ name: 'changelog' }"
                class="primary"
                style="--link-color: var(--fa-navy); --link-hover-color: var(--grape8)"
              >
                See what's new &rarr;
              </site-link>
            </p>
          </div>
          <div class="display-flex align-middle laptop:padding-0">
            <site-link
              v-if="isActiveProPlus"
              :to="$icons()"
              class="button flat with-border margin-0"
              :style="ctaButtonStyle"
            >
              Explore the Packs
            </site-link>

            <site-link
              v-else
              :to="{ name: 'plans.pro-plus' }"
              class="button flat with-border margin-0"
              :style="ctaButtonStyle"
              @click="
                purchaseFlowEvent('get_pro_button_click', {
                  context: 'new_release_bandana',
                  required_pro_level: 'plus',
                  featured: 'seven-three'
                })
              "
            >
              Get it all with Pro+!
            </site-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { EventTrackingMixin } from 'app/mixins'

  export default {
    name: 'NewPackNotice',

    mixins: [EventTrackingMixin],

    computed: {
      isActivePro() {
        return Boolean(this.$dt?.isPro && this.$dt?.active)
      },
      isActiveProPlus() {
        return Boolean(this.$permits?.has?.('accessToProPlus') && this.$dt?.active)
      },
      headlineText() {
        if (this.isActiveProPlus) {
          return '7.3.0 is here with three new icon packs - and more'
        }
        return 'New icons and three new Pro+ packs now out in v7.3.0'
      },
      ctaButtonStyle() {
        return {
          '--button-color': 'var(--fa-navy)',
          '--border-color': 'var(--fa-dk-purple)',
          '--button-background': 'var(--fa-purple)',
          '--button-hover-color': 'var(--grape1)',
          '--button-hover-background': 'var(--fa-dk-purple)',
          '--button-hover-border-color': 'var(--fa-dk-purple)'
        }
      }
    }
  }
</script>
